import Resize from './resize';
import webglManager from './webgl';

let _resize = new Resize();
let _webgl = new webglManager();

export default class movieManager {
    constructor(_root,_path){

        this.movieModal = $("#c-movie-modal");
        this.movieModalView = $("#c-movie-modal__view");
        this.movieSrc = '';
        this.movieFrame = '';
        this.movieIndex = '';

        this.movieBg = '';

        this.ytPlayer = [];
        this.number = 0;

    }
    bgSet(_status,_root,_path) {

        let _this = this;

        // movie set
        if (!Useragnt.mobile) {
            let _moviebg = '<video id="c-movie-bg__iot1" class="js__resize-full" loop="loop" muted="muted">' +
                '<source src="' +_root + _path + 'images/iot01.mp4" type="video/mp4" /> ' +
                '</video>' +
                '<video id="c-movie-bg__iot2" class="js__resize-full" loop="loop" muted="muted">' +
                '<source src="' + _root + _path + 'images/iot02.mp4" type="video/mp4" />' +
                '</video>' +
                '<video id="c-movie-bg__digital-twin" class="js__resize-full" loop="loop" muted="muted">' +
                '<source src="' + _root + _path + 'images/digitaltwin.mp4" type="video/mp4" />' +
                '</video>';
            $('#c-movie-bg').append(_moviebg);
        }

    }
    set(_status){

        let _this = this;

        // youtube api
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        let _area = [];
        let _ID = [];
        let $youtube = $('.c-movie');
        let i;
        let _num = 0;
        let ytStatus;

        window.onYouTubeIframeAPIReady = function () {

            for (i=0; i<$youtube.length; i++) {

                _num = i + 1;
                _ID[i] = $youtube.eq(i).data('youtube');
                _area[i] = 'c-movie-modal__view'+_num;

                _this.ytPlayer[i] = new YT.Player(
                    _area[i],
                    {
                        width: 910,
                        height: 520,
                        videoId: _ID[i],
                        playerVars: {
                            controls: 1, // コントロールバーを表示しない
                            showinfo: 0, // 動画情報を表示しない
                            rel     : 0, // 関連動画を表示しない
                        },
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        }
                    }
                );
            }

        }
        function onPlayerReady(e) {
            for (i = 0; i < $youtube.length; i++) {
                _num = i + 1;
                if(e.target.getIframe().id == 'c-movie-modal__view'+_num) {
                    //playVideo(i);
                }
            }
        }
        function onPlayerStateChange(event) {

            let _state = event.data;
            if(_state == YT.PlayerState.ENDED || _state == YT.PlayerState.PAUSED) {
                if(Useragnt.mobile){
                    _this.close(_status);
                }
            }

        }

        /* -----------------------------------------------

         -- event

         -------------------------------------------------- */

        let _movieTrigger = $(".c-movie");
        let _movieModalClose = $("#c-movie-modal__close,#c-movie-modal__bg");

        //open
        _movieTrigger.on('click', function() {
            let _target = $(this);
            _this.open(_status,_target);
            _this.playVideo(_target);
        });
        //close
        _movieModalClose.on('click', function() {
            _this.pauseVideo(_status);
            _this.close(_status);
        });

    }
    playVideo(_target) {

        let _this = this;
        _this.number = _target.data('number');
        _this.ytPlayer[_this.number].playVideo();

    }
    pauseVideo(_status) {

        let _this = this;
        _this.ytPlayer[_this.number].pauseVideo();

    }
    open(_status,_target){

        let _this = this;

        _status.Flg = true;

        $('#c-movie-modal__view>*').removeClass('is-show');
        $('#c-movie-modal__view>*').eq(_target.data('number')).addClass('is-show');
        TweenMax.fromTo(_this.movieModal, .45, {
            x: '-10px',
            autoAlpha: 0,
            display:'none',
        },{
            x:0,
            autoAlpha: 1,
            display:'block',
            easing:Expo.easeOut
        });
    }
    close(_status){

        let _this = this;

        TweenMax.to(_this.movieModal, .45, {
            x:'-10px',
            autoAlpha: 0,
            display:'none',
            easing:Expo.easeOut,
            onComplete:function(){
                _this.movieModal.removeAttr('style');
                _resize.set();
                _status.Flg = false;
            }
        });
    }
    bgPlay(_status,_target){

        let _this = this;

        switch (_target) {
            case 'l-iot': // --------------- iot (start) --------------- //

                _this.movieBg = $('#c-movie-bg__iot'+_status.iotMovie).get(0);

                TweenMax.to($('#c-movie-bg,#c-movie-bg__iot'+_status.iotMovie), .45, {
                    delay:1.2,
                    autoAlpha: 1,
                    display:'block',
                    easing:Expo.easeOut,
                    onComplete:function(){
                        _this.movieBg.play();
                        _webgl.startstop(_status);
                        // if(_status.iotMovie === 1){
                        //     _status.iotMovie = 2;
                        // }else if(_status.iotMovie === 2){
                        //     _status.iotMovie = 1;
                        // }
                    }
                });

                break; // --------------- iot (end) --------------- //

            case 'l-digital-twin': // --------------- digitaltwin (start) --------------- //
                // motion

                _this.movieBg = $('#c-movie-bg__digital-twin').get(0);

                TweenMax.to($('#c-movie-bg,#c-movie-bg__digital-twin'), .45, {
                    delay:1.4,
                    autoAlpha: 1,
                    display:'block',
                    easing:Expo.easeOut,
                    onComplete:function(){
                        _this.movieBg.play();
                        _webgl.startstop(_status);
                    }
                });

                break; // --------------- digitaltwin (end) --------------- //
        }

    }
}

